module.exports = __webpack_public_path__ + "img/sllr_EN.262db68a.jpg";